import { patchRequest } from "../httpMethods";

export const patchMarkAllRead = (id) =>
    patchRequest(`ticket-chat/read/${id}`);

export const patchLeaveStatus = (id, payload) =>
    patchRequest(`trainer-leaves/update-status/${id}`, payload);



export const patchUpdatedZone = (id, payload) =>
    patchRequest(`zones/assign/${id}`, payload);